import { useRef } from 'react';
import isEqual from 'react-fast-compare';
import isEqualWith from 'lodash/isEqualWith';
// This hook memoizes a value passed based on deep equality.
// Note that it doesn't save you on calculation time like useMemo,
// and it can get slow on huge objects. However it can help you avoid
// re-renders by keeping the value reference identical.
export function useDeepEqualMemo(value) {
    var memoizedValue = useRef(value);
    // only update the value if it's not deep equal
    if (!isEqual(value, memoizedValue.current)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
// Similar to above, but uses a customizable item equality compare function
export function useDeepEqualCustomMemo(value, customComparison) {
    var memoizedValue = useRef(value);
    // only update the value if it's not deep equal
    if (!isEqualWith(value, memoizedValue.current, customComparison)) {
        memoizedValue.current = value;
    }
    return memoizedValue.current;
}
//# sourceMappingURL=useDeepEqualMemo.js.map